/** 链类型 */
export enum WalletChainTypes {
  EVM = 1,
  SUI = 2,
  SOLANA = 3,
  BTC = 4,
}

export enum ChainCodeTypes {
  EVM = 'EVM',
  SUI = 'SUI',
  SOL = 'SOL',
  STX = 'STX',
  TON = 'TON',
}

/** 链数据 */
export type Chain = {
  /** 链ID */
  chainId: number;
  /** 链Code */
  chainCode: string;
  /** 链名称 */
  chainName: string;
  /** 日间图标 */
  iconDayUrl: string;
  /** 夜间图标 */
  iconNightUrl: string;
  /** 基础币种 */
  baseTokenName: string;
  /** @deprecated 基础币种 */
  baseToken: string;
  /** 网络 */
  networkName: string;
  /** 排序  */
  order: number;
  /** 支持L1的Gas */
  isSupportL1Gas: number;
  /** 链类型 */
  chainType: WalletChainTypes;
  /** 区分EIP1559，暂时无用 */
  gasType: 1;
  /** txAddress */
  txAddress: string;
  /** 链是否开放 */
  tmpStatus: 'open' | 'close';
  /** 创建时间 */
  createAt: number;
  /** 最小交易金额 */
  minTransaction: string;
};

export type ChainStore = Record<string, Chain>;

export type WalletChains = {
  CLOUD: { itemList: Chain[] };
  MNEMONIC_PHRASE: { itemList: Chain[] };
};

export type GetChainListRes = {
  walletChains: WalletChains;
};
